import * as React from 'react';
import ICheckedMark from './ICheckedMark';

import * as style from './CheckedMarkStyle.module.scss'

const CheckedMark = (props: ICheckedMark) => {

  return (
    <div className={props.center ? style.checkedCenter : style.checked}>
      <span className={style.line1} />
      <span className={style.line2} />
      <svg width="100" height="100">
        <circle className={style.background} cx="50" cy="50" r="45"/>
        <circle className={style.loader} cx="50" cy="50" r="45"/>
      </svg>
    </div>
  );
};

export default CheckedMark;
